import React, { useContext, useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { Storage } from "aws-amplify";
import filesize from "filesize";
import toast from "react-hot-toast";
import { getId, compressImage } from "../../../Utility";
import { Context } from "../../../Utility/ContextManager";
import { createRecordTB } from "../../../Utility/ApiService";

export const MyDropzone = forwardRef((props, ref) => {
  const [pickedFiles, setPickedFfile] = useState([]);
  const { user } = useContext(Context);

  const {
    propertyDetail,
    setLoading,
    fetchAllPropertyUnitDocs,
    text,
    isMaintenance,
    setMaintenanceAttachments,
    removeBorder,
    // removeDocs,
  } = props;

  useImperativeHandle(ref, () => ({
    getAlert() {
      setPickedFfile([]);
    },
  }));

  const onDrop = (acceptedFiles) => {
    for (let i = 0; i < acceptedFiles.length; i++) {
      acceptedFiles[i].uploaded0 = false;
      acceptedFiles[i]["descriptions"] = "";
    }
    setPickedFfile([...pickedFiles, ...acceptedFiles]);
    if (isMaintenance) {
      setMaintenanceAttachments([...pickedFiles, ...acceptedFiles]);
    }
  };

  const { getRootProps, getInputProps, isDragActive, fileRejections } = useDropzone({
    onDrop,
    accept: {
      "image/jpeg": [".jpeg", ".jpg", ".png"],
      "image/png": [".png"],
      "application/pdf": [".pdf"],
      "text/plain": [".txt"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
      "application/msword": [".doc"],
    },
  });

  useEffect(() => {
    if (fileRejections.length > 0) {
      toast.error("File type not supported");
    }
  }, [fileRejections]);

  const removeFile = (removeFile1) => {
    const filteredFile = pickedFiles.filter((file) => removeFile1 !== file);
    setPickedFfile(filteredFile);
  };

  const addPhotosToS3 = async (file) => {
    try {
      setLoading(true);

      const compressedFile = await compressImage(file);
      await Storage.put(`property/${file.name}`, compressedFile, {
        level: "public",
        contentType: file.type,
      });

      const propertyUnitDoc = {
        created_at: new Date(),
        created_by: user.id,
        document_name: file.name,
        document_type: file.type,
        tenant_id: user.id,
        id: getId(),
        active: 1,
        property_unit_id: propertyDetail?.property_unit_id,
        description: file.descriptions,
      };
      await createRecordTB("PropertyUnitDocument", propertyUnitDoc);

      removeFile(file);
      fetchAllPropertyUnitDocs(user);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error uploading file: ", error);
    }
  };

  return (
    <div>
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <div className="uploadBtn">
            <strong>Drop the files here...</strong>
          </div>
        ) : (
          <div>
            <div
              className={!removeBorder ? "uploadBtn" : "text-center text-link"}
              style={removeBorder ? { color: "#1a5e61", cursor: "pointer" } : null}
            >
              <strong>{text}</strong>
            </div>
            <div className="dropzone-previews"></div>
            {/* end preview tempalte */}
          </div>
        )}
      </div>
      {pickedFiles?.map((file, index) => (
        <div key={index} className="card">
          <div className="dz-details">
            <div className="d-flex align-items-center justify-content-between mb-2 p-3">
              {!isMaintenance && (
                <div className="dz-success-mark" data-cy="uploadcheck">
                  <img
                    onClick={() => {
                      addPhotosToS3(file);
                    }}
                    src={require("../../../assets/images/check.svg").default}
                    alt=""
                    className="cursor-pointer"
                  />
                </div>
              )}
              <div className="dz-filename">
                <span>{file?.path}</span>
                <span className="fileSize">{filesize(file?.size)}</span>
              </div>

              <div className="dz-remove text-end">
                <a onClick={() => removeFile(file)} className="cursor-pointer" data-dz-remove="">
                  <img src={require("../../../assets/images/close-file.svg").default} alt="" />
                </a>
              </div>
            </div>
            {!isMaintenance && (
              <div className="dz-description">
                <input
                  type="text"
                  value={file.descriptions}
                  onChange={(e) => {
                    pickedFiles[index]["descriptions"] = e.target.value;
                    setPickedFfile([...pickedFiles]);
                  }}
                  placeholder="Description"
                  className="form-control"
                />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
});
